import { i18n } from '@/common/utils/i18n'

export const BIZDAY_OPTIONS = [
  {
    label: i18n.gettext('周一'),
    value: 1
  },
  {
    label: i18n.gettext('周二'),
    value: 2
  },
  {
    label: i18n.gettext('周三'),
    value: 3
  },
  {
    label: i18n.gettext('周四'),
    value: 4
  },
  {
    label: i18n.gettext('周五'),
    value: 5
  },
  {
    label: i18n.gettext('周六'),
    value: 6
  },
  {
    label: i18n.gettext('周日'),
    value: 7
  }
]

export const BIZDAY_GAS_OPTIONS = [
  {
    label: i18n.gettext('周一'),
    value: 'Monday'
  },
  {
    label: i18n.gettext('周二'),
    value: 'Tuesday'
  },
  {
    label: i18n.gettext('周三'),
    value: 'Wednesday'
  },
  {
    label: i18n.gettext('周四'),
    value: 'Thursday'
  },
  {
    label: i18n.gettext('周五'),
    value: 'Friday'
  },
  {
    label: i18n.gettext('周六'),
    value: 'Saturday'
  },
  {
    label: i18n.gettext('周日'),
    value: 'Sunday'
  }
]
export const COMMOTMENT_OPTIONS = [
  {
    text: i18n.gettext('承诺'),
    value: '1'
  },
  {
    text: i18n.gettext('不承诺'),
    value: '2'
  },
  {
    text: i18n.gettext('待定'),
    value: '3'
  }
]

export const NEED_PAD_OPTIONS = [
  {
    text: i18n.gettext('需要'),
    value: '1'
  },
  {
    text: i18n.gettext('不需要'),
    value: '0'
  }
]

export const COMPETITORS_PLATFORM_LIST = [
  {
    label: 'Uber Eats',
    value: 'ubereats'
  },
  {
    label: 'Sindelantal',
    value: 'sindelantal'
  },
  {
    label: 'Rappi',
    value: 'rappi'
  }
]
